import { render, staticRenderFns } from "./product-translations-modal.vue?vue&type=template&id=5ff8d8d6&"
import script from "./product-translations-modal.vue?vue&type=script&lang=js&"
export * from "./product-translations-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports